import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { isPromoActive, goToPricing } from "@/utils/promo";
import { trackEvent } from "@/utils/analytics";

const PromoBanner = () => {
  const navigate = useNavigate();
  if (!isPromoActive()) return null;

  return (
    <div data-testid="promo-banner" className="bg-navy px-4 py-2.5 text-center">
      <p className="text-xs font-semibold text-white/85 sm:text-[13px]">
        <span className="font-bold text-turquoise">390 € HT</span> de mise en service & paramétrage offerts jusqu'au 30 septembre
        <button
          data-testid="promo-banner-cta"
          onClick={() => { trackEvent("promo_cta_click", { location: "banner" }); goToPricing(navigate); }}
          className="group ml-3 inline-flex items-center gap-1 font-bold text-white underline decoration-turquoise decoration-2 underline-offset-4 transition-colors hover:text-turquoise"
        >
          En profiter
          <ArrowRight className="h-3 w-3 transition-transform duration-300 group-hover:translate-x-0.5" />
        </button>
      </p>
    </div>
  );
};

export default PromoBanner;
